export default {"src":"/_next/static/media/shrubs.75b057b0.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};